var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({attrs:{"disabled":_vm.disabled}},_vm.$listeners),[_c('span',{staticClass:"icon icon-add"}),_vm._v("\n\t"+_vm._s(_vm.t('settings', 'Add'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }